import React from 'react';
import {Tooltip} from 'antd';
import {useTranslation} from 'react-i18next';

export const SYSTEM_CRITERION_KIND = Object.freeze({
    GLOBAL_REVIEW: 'global_review',
    DOCUMENT_COMPARISON: 'document_comparison',
    REFERENCE_REVIEW: 'reference_review',
});

const GlobalReviewMark = () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <path d="M12 2.4 20.2 7v10L12 21.6 3.8 17V7L12 2.4Z" />
        <path d="m3.8 7 8.2 4.7L20.2 7M12 11.7v9.9" />
        <circle cx="12" cy="11.7" r="2.15" />
    </svg>
);

const DocumentComparisonMark = () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <path d="M3.4 5.2h11.2v14H3.4z" />
        <path d="M8.8 2.8h11.8v14H17" />
        <path d="M7 9.2h4M7 12.2h4M7 15.2h2.5" />
    </svg>
);

const ReferenceReviewMark = () => (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
        <path d="M5 3v18M9.2 3v18M9.2 5h9.8M9.2 10h6.4M9.2 15h9.8M9.2 20h6.4" />
        <path d="M3 3h4M3 21h4" />
    </svg>
);

const MARKS_BY_KIND = {
    [SYSTEM_CRITERION_KIND.GLOBAL_REVIEW]: GlobalReviewMark,
    [SYSTEM_CRITERION_KIND.DOCUMENT_COMPARISON]: DocumentComparisonMark,
    [SYSTEM_CRITERION_KIND.REFERENCE_REVIEW]: ReferenceReviewMark,
};

const SystemCriterionIcon = ({kind, criterionName}) => {
    const {t} = useTranslation('review');
    const Mark = MARKS_BY_KIND[kind];
    if (!Mark || !criterionName) return null;

    const accessibleLabel = t('systemCriterion.iconLabel', {
        defaultValue: 'Critère système',
    });
    const tooltipLabel = t('systemCriterion.tooltip', {
        criterionName,
        defaultValue: `Critère système — ${criterionName}`,
    });

    return (
        <Tooltip title={tooltipLabel} placement="top">
            <span
                className={`system-criterion-icon is-${kind}`}
                role="img"
                aria-label={accessibleLabel}
                tabIndex={0}
                data-system-criterion-kind={kind}
            >
                <Mark />
            </span>
        </Tooltip>
    );
};

export default SystemCriterionIcon;
